import uiEnums from 'enums/ui';
import uiEvents from 'events/ui';
import showWidget from 'actions/ui/showWidget';

export default function beginChat() {
  return dispatch => {
    dispatch(uiEvents.updateStage(uiEnums.STAGES.CHAT));
    dispatch(showWidget());
  };
}
